import { ServerModuleState } from "./ServerModule-State";

export default function serverModuleListReducer(
  state = ServerModuleState,
  action
) {
  let { data } = JSON.parse(JSON.stringify(state));
  let { name, value, data_center_id } = action;

  switch (action.type) {
    case "TOGGLE-SERVER-MODULE-LIST-FILTER":
      if (name === `sort_by`) {
        if (data.params.sort_by === value) {
          data.params.sort_order =
            data.params.sort_order === `desc` ? `asc` : `desc`;
        }
      }
      let toggle = true;
      if (toggle) {
        if (name === "limit") {
          data.params.page = 1;
        }
        data.params[name] = value;
      }
      return { ...state, data };

    case "ON-SERVER-DATA-CENTER-CHANGE":
      data.params.data_center_id = data_center_id;
      return { ...state, data };

    case "ON-SERVER-RESET":
      data.params.data_center_id = ``;
      return { ...state, data };

    case "TOGGLE-RESET-SERVER":
      data.params.page = 1;
      data.params.q = "";
      data.payload.initialLoading = true;
      return { ...state, data };

    case "ON-DATA-CENTER-SELECT-CHANGE":
      data.data_center_id = data_center_id;
      return { ...state, data };

    default:
      return state;
  }
}
